import { HcStructureMenu } from '@hotmart-org-ca/cosmos-web/dist/react/hc-structure'
import { dark } from '@space-lib/styles/themes'
import styled, { css } from 'styled-components'

import type { Theme } from './types'

import { SessionMode } from '../enum'

export const menuStyle = css`
  .hc-structure-menu .hc-structure-menu__items::-webkit-scrollbar {
    width: 0.5rem;
  }

  .hc-structure-menu .hc-structure-menu__items::-webkit-scrollbar-track {
    background-color: var(--gray-100);
    height: var(--spacer-2);
    width: var(--spacer-2);
  }

  .hc-structure-menu .hc-structure-menu__items::-webkit-scrollbar-thumb {
    background-color: var(--gray-300);
    border-radius: var(--border-radius-sm);
  }

  .hc-structure-menu .hc-structure-menu__items::-webkit-scrollbar-thumb:hover {
    background-color: var(--gray-400);
  }

  .hc-structure-menu .hc-structure-menu__items,
  .hc-structure-menu slot[name='footer'] {
    box-shadow: 0 0.25rem 1.875rem rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(1rem);
    -webkit-backdrop-filter: blur(1rem);
  }
`

export const HcMenu = styled(HcStructureMenu)<{
  $session: SessionMode
  $theme?: Theme
  $isViewAs?: boolean
}>`
  --hc-structure-menu-items-gap: 0;

  --hc-structure-menu-border-bottom-inline-end: 0.063rem solid var(--bg-primary);
  --hc-structure-menu-footer-border-top: 0.063rem solid var(--gray-200);
  --hc-structure-menu-background-color: transparent;

  ${({ $theme, $isViewAs, $session }) =>
    `
      --hc-structure-menu-z-index: 11;
      --hc-structure-menu-items-background-color: ${
        $theme === dark.title ? 'rgba(14, 16, 18, 0.8)' : 'rgba(255, 255, 255, 0.8)'
      };
      --hc-structure-menu-footer-background-color: ${
        $theme === dark.title ? 'rgba(14, 16, 18, 0.8)' : 'rgba(255, 255, 255, 0.8)'
      };
      ${$isViewAs && '--hc-structure-menu-top: 9.125rem'};
      ${$session === SessionMode.PREVIEW && '--hc-structure-menu-position: absolute;'};
      ${$session === SessionMode.PREVIEW && '--hc-structure-menu-scroll-hover-overflow-y: none'};
      ${
        $session === SessionMode.PREVIEW &&
        '--hc-structure-menu-opened-backdrop-pointer-events: none'
      };
      ${
        $session === SessionMode.PREVIEW &&
        '--hc-structure-menu-scroll-hover-padding-inline-end: 0.5rem'
      };
    `}
`
